export function formatCheckedDate(value, timeZone) {
  if (!value) return '';
  const text = String(value);
  const calendarDate = /^\d{4}-\d{2}-\d{2}$/.test(text);
  const date = new Date(calendarDate ? `${text}T12:00:00Z` : text);
  if (!Number.isFinite(date.getTime())) return '';
  return new Intl.DateTimeFormat('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
    ...(calendarDate ? { timeZone: 'UTC' } : { timeZone, hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }),
  }).format(date);
}

export function conferenceFreshness(value, now = Date.now()) {
  const checked = Date.parse(value || '');
  if (!Number.isFinite(checked)) return { label: 'Check time unavailable', aging: false };
  const minutes = Math.max(0, Math.floor((now - checked) / 60000));
  return { label: minutes < 1 ? 'Checked just now' : minutes < 60 ? `Checked ${minutes} min ago`
    : `Checked ${Math.floor(minutes / 60)}h ${minutes % 60}m ago`, aging: minutes >= 120 };
}
